<input type="file" [ngStyle]="{'display': cnf.input?'initial':'none'}" (change)="onFileChanged($event)" [id]="cnf.id">
<button *ngIf="cnf.choos_button" (click)="onChoose(cnf.id)" class="btn btn-default">انتخاب فایل</button>
<button *ngIf="cnf.upload_button" (click)="onUpload()" class="btn btn-default">بارگذاری</button>